import React, { useEffect } from "react";
import { IAgreementState } from "../../../../redux/types/IAgreementState";
import { Empty, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { CANCEL_SORTING, NO_DATA, SORT_ASCENDING, SORT_DESCENDING } from "../../../Consts";

interface IDraftAgreementsAssigneeReviewProps {
    agreement: IAgreementState;
    draftAgreementMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;
}

const DraftAgreementsAssigneeReview: React.FC<IDraftAgreementsAssigneeReviewProps> = ({
    agreement,
    draftAgreementMaintenanceGeneralDataViewData
}) => {
  const [agreementData, setAgreementData] = React.useState([]);
  const [viewData, setViewData] = React.useState([])

  useEffect(() => {

    if (agreement?.agreementAdminIP) {

    const dataSource = agreement.agreementAdminIP.map((assignee, index) => ({
      key: index,
      name: assignee.administeredName.value,
      assigneeNameNumber: assignee.administeredIP.value,
      mechanicalShare: (Number((assignee.mechanicalShare.value)).toFixed(2)),
      creatorRetainedMechShare: (Number((assignee.creatorRetainedMechShare.value)).toFixed(2)),
      publisherRetainedMechShare: (Number((assignee.publisherRetainedMechShare.value)).toFixed(2)),
      performingShare:(Number((assignee.performingShare.value)).toFixed(2)),
      creatorRetainedPerShare: (Number((assignee.creatorRetainedPerShare.value)).toFixed(2)),
      publisherRetainedPerShare: (Number((assignee.publisherRetainedPerShare.value)).toFixed(2)),
      societyAffiliation: assignee.societyAffiliation?.value ? assignee.societyAffiliation.value : "",
  }));
  setAgreementData(dataSource)
  }
  }, [agreement]);

  useEffect(() => {
      if (draftAgreementMaintenanceGeneralDataViewData?.fields) {
          const visibleFields = draftAgreementMaintenanceGeneralDataViewData.fields.filter(field => !field.hidden);
          let newViewData = [];
          visibleFields.forEach(item => {
              newViewData[item.name] = item.data;
          });
          setViewData(newViewData);
      }
  
  }, [agreement, draftAgreementMaintenanceGeneralDataViewData]);

    const columns: ColumnsType<any>  = [
        {
            title: viewData['assigneeName'] || 'Assignee Name',
            dataIndex: 'name',
            key: 'name',
          },
          {
            title: viewData['assigneeNameNumber'] || 'Assignee Name Number',
            dataIndex: 'assigneeNameNumber',
            key: 'assigneeNameNumber',
          },
          {
            title: viewData['mechShareAssigned'] || 'Mech Share Assigned',
            dataIndex: 'mechanicalShare',
            key: 'mechanicalShare',
          },
          {
            title: viewData['creatorRetainedMechShare'] || 'Creator Retained Mech Share',
            dataIndex: 'creatorRetainedMechShare',
            key: 'creatorRetainedMechShare',
          },
          {
            title: viewData['publisherRetainedMechShare'] || 'Publisher Retained Mech Share',
            dataIndex: 'publisherRetainedMechShare',
            key: 'publisherRetainedMechShare',
          },
          {
            title: viewData['perfShareAssigned'] || 'Perf Share Assigned',
            dataIndex: 'performingShare',
            key: 'performingShare',
          },
          {
            title: viewData['creatorRetainedPerfShare'] || 'Creator Retained Perf Share',
            dataIndex: 'creatorRetainedPerShare',
            key: 'creatorRetainedPerShare',
          },
          {
            title: viewData['publisherRetainedPerfShare'] || 'Publisher Retained Perf Share',
            dataIndex: 'publisherRetainedPerShare',
            key: 'publisherRetainedPerShare',
          },
          {
            title: viewData['societyAffiliation'] || 'Society Affiliation',
            dataIndex: 'societyAffiliation',
            key: 'societyAffiliation',
          },
]


    return <div className={``}>
                    <div className="headerContainer">
            <div
                className={["headerSection", "activeSection"].join(" ")}
                key={'Assignee'}
                data-testid={'Assignee' + "-section"}
            >
                {viewData['draftAgreementReviewAssignee']}
            </div>
        </div>
        <div className='assigneeTable'>
        <Table 
          dataSource={agreementData} 
          columns={columns}  
          locale={{
            emptyText: (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={viewData[NO_DATA]}
                />
            ),
            triggerDesc: viewData[SORT_DESCENDING],
            triggerAsc: viewData[SORT_ASCENDING],
            cancelSort: viewData[CANCEL_SORTING],
          }}
        />
        </div>
    </div>
}

export default DraftAgreementsAssigneeReview;